import { render, staticRenderFns } from "./mailerLiteGroupInfo.vue?vue&type=template&id=3827cec1&"
import script from "./mailerLiteGroupInfo.vue?vue&type=script&lang=js&"
export * from "./mailerLiteGroupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports